export default {
	price: '{price} {suffix}',
	sectionTitle: 'You might also like',
	seeAllLink: 'See all',
};
